// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var EditSolid = function EditSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editsolid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m3.977-14.543.562.563c.61.609.61 1.597 0 2.21l-.836.836-2.773-2.773.836-.836c.609-.61 1.597-.61 2.21 0m-8.043 5.832 4.109-4.11 2.773 2.774-4.109 4.106c-.16.16-.36.273-.582.328l-2.348.586a.62.62 0 0 1-.593-.164.62.62 0 0 1-.164-.594l.585-2.348c.055-.219.168-.422.329-.582z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editsolid-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
